// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout-module--content--3KiRz","contentWithCart":"Layout-module--contentWithCart--2YP47"};